import { Dimensions, Parcel } from '~api/som';

import { Fragment, PropsWithChildren } from 'react';
import { FormState, UseFormRegister } from 'react-hook-form';

import { FormItem } from '@ingrid/luterkort-react';

import { NumberInput } from '~src/components/NumberInput/NumberInput';
import { useTranslation } from '~src/i18n/use-translation';

interface Props {
  register: UseFormRegister<Pick<Parcel, 'dimensions'>>;
  formState: FormState<{ dimensions?: Dimensions }>;
}

function XWrapper({ children }: PropsWithChildren) {
  return (
    <div
      style={{
        alignItems: 'center',
        display: 'flex',
        gap: '4px',
      }}
    >
      {children}
    </div>
  );
}

function XMark() {
  return (
    <span
      style={{
        color: 'var(--grey-99)',
        fontSize: '14px',
      }}
    >
      x
    </span>
  );
}

export function DimensionFields({ register, formState }: Props) {
  const { t } = useTranslation();

  return (
    <Fragment>
      <FormItem.Root>
        <FormItem.Label>{t('common.length')}</FormItem.Label>

        <XWrapper>
          <FormItem.Control invalid={!!formState.errors.dimensions?.length}>
            <NumberInput
              {...register('dimensions.length', { valueAsNumber: true, min: 0 })}
              data-invalid={!!formState.errors.dimensions?.length}
              decimals={false}
              suffix="mm"
            />
          </FormItem.Control>
          <XMark />
        </XWrapper>
      </FormItem.Root>

      <FormItem.Root>
        <FormItem.Label>{t('common.width')}</FormItem.Label>

        <XWrapper>
          <FormItem.Control invalid={!!formState.errors.dimensions?.width}>
            <NumberInput
              {...register('dimensions.width', { valueAsNumber: true, min: 0 })}
              data-invalid={!!formState.errors.dimensions?.width}
              decimals={false}
              suffix="mm"
            />
          </FormItem.Control>
          <XMark />
        </XWrapper>
      </FormItem.Root>

      <FormItem.Root>
        <FormItem.Label>{t('common.height')}</FormItem.Label>
        <FormItem.Control invalid={!!formState.errors.dimensions?.height}>
          <NumberInput
            {...register('dimensions.height', { valueAsNumber: true, min: 0 })}
            data-invalid={!!formState.errors.dimensions?.height}
            decimals={false}
            suffix="mm"
          />
        </FormItem.Control>
      </FormItem.Root>
    </Fragment>
  );
}
